import { userConstants } from "../../constant";

const initialState = {
  loaded: false,
  not_found: false,
  owner_name: "",
  no_variants: [],
  variants: [],
};

export function sharedWishlist(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_SHARED_WISHLIST:
      if (action.payload.not_found) {
        return { ...initialState, loaded: true, not_found: true };
      }
      return {
        loaded: true,
        not_found: false,
        owner_name: action.payload.owner_name,
        folder_name: action.payload.folder_name || "",
        no_variants: action.payload.no_variants,
        variants: action.payload.variants,
      };
    default:
      return state;
  }
}
